export function addClientFilteringMetaData(client) {
    client.filteringMetaData = client.websites
        .map((w) => [w.name, w.convenienceName, w.partnerContact, w.clientContact])
        .reduce((a, b) => a.concat(b), [])
        .join(' ');
}
